<app-filter-form
  #filterForm
  [filters]="submittedQueryFilters()"
  [filtersForExport]="submittedQueryFilters()"
  [entity]="'product-moves'"
  [totalItems]="totalItems()"
  (onExportResult)="queryProductMoves.refetch()"
  (onClearClick)="clearFilters()"
  (onSubmit)="submitFilters()"
  (onCreateModalHidden)="filter_form?.exportsModal.showChildModal()"
  [isFilterInvisible]="false"
  [areExportsInFilter]="true"
  [isExportButtonShown]="true"
  [filterVisible]="filtersExpanded"
  [loading]="loadingFilters()"
>
  <div class="container-fluid ps-0 pe-0">
    <!--      FIRST ROW OF INPUTS-->
    <div class="row mr-0">
      <div class="col-12 col-sm-6 col-md-3 col-xl-2">
        <form-row-select
          [label]="'stock.load.type'"
          [model]="filters().type"
          (modelChange)="setFilter('type', $event)"
          [options]="operationTypes"
          [btnLabel]="
            selectedOperationType === 'transfer' && selectedDepotFrom > 0 && selectedDepotTo > 0 ? 'depots.switch' : ''
          "
          [btnClasses]="['btn-third']"
          (onBtnEvent)="switchDepots()"
          [icon]="null"
          [dataCyAttribute]="'product-moves-operation-type-filter'"
        ></form-row-select>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-xl-1">
        <form-row-input
          [label]="'date.from'"
          [icon]="null"
          [inputType]="'date'"
          [model]="filters().created?.left_date"
          (modelChange)="setFilter('created', $event, 'left_date')"
          (keydown.enter)="submitFilters()"
          [dataCyAttribute]="'product-moves-date-from-filter'"
        ></form-row-input>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-xl-1">
        <form-row-input
          [label]="'date.to'"
          [icon]="null"
          [inputType]="'date'"
          [model]="filters().created?.right_date"
          (modelChange)="setFilter('created', $event, 'right_date')"
          (keydown.enter)="submitFilters()"
          [dataCyAttribute]="'product-moves-date-to-filter'"
        ></form-row-input>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-xl-2">
        <form-row-select
          [label]="'product.batch'"
          [model]="filters().batch"
          (modelChange)="setFilter('batch', $event)"
          [options]="batches"
          [icon]="null"
          [dataCyAttribute]="'product-moves-batch-filter'"
        ></form-row-select>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-xl-2">
        <form-row-select
          [label]="'expiration'"
          [icon]="null"
          [model]="selectedExpiration"
          (modelChange)="setExpirationFilter($event)"
          [options]="expirations"
          [dataCyAttribute]="'product-moves-selected-expiration-filter'"
        ></form-row-select>
        @if (selectedExpiration === 'custom') {
          <form-row-input
            [icon]="null"
            [inputType]="'date'"
            [model]="expirationDateOnly()"
            (modelChange)="setExpirationFilter(null, $event)"
          ></form-row-input>
        }
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-xl-2">
        <form-row-select
          [label]="'createdBy'"
          [icon]="null"
          [options]="users()"
          [optionKey]="'id'"
          [optionKeyText]="'name'"
          [model]="filters().createdBy"
          (modelChange)="setFilter('createdBy', $event)"
          [dataCyAttribute]="'product-moves-email-filter'"
        ></form-row-select>
      </div>
      <!--    todo pridat do filteru-->
      <!--    <div class="col-12 col-sm-6 col-md-3 col-xl-2">-->
      <!--      <form-row-select-multiple-->
      <!--        [label]="'tags'"-->
      <!--        [(selectedValues)]="filterTags"-->
      <!--        [options]="tags"-->
      <!--        [isTags]="true"-->
      <!--        [dataCyAttribute]="'product-moves-tags-filter'"-->
      <!--      ></form-row-select-multiple>-->
      <!--    </div>-->

      <!--    <div class="col-12 col-sm-6 col-md-3 col-xl-2">-->
      <!--      <form-row-select-multiple-->
      <!--        [label]="'tagsNegate'"-->
      <!--        [(selectedValues)]="filterTagsNegate"-->
      <!--        [options]="tags"-->
      <!--        [isTags]="true"-->
      <!--        [dataCyAttribute]="'product-moves-tagsNegate-filter'"-->
      <!--      ></form-row-select-multiple>-->
      <!--    </div>-->
      @if (!isInSelected()) {
        <div class="col-12 col-sm-6 col-md-3" [ngClass]="isOutSelected() ? 'col-xl-2' : 'col-xl-1'">
          <form-row-select
            [label]="'depot.from'"
            [model]="filters().depotFrom"
            (modelChange)="setFilter('depotFrom', $event)"
            [options]="productDetailService.depotOptions()"
            [icon]="null"
            [dataCyAttribute]="'product-moves-depot-from-filter'"
          ></form-row-select>
        </div>
      }
      @if (!isOutSelected()) {
        <div class="col-12 col-sm-6 col-md-3" [ngClass]="isInSelected() ? 'col-xl-2' : 'col-xl-1'">
          <form-row-select
            [label]="'depot.to'"
            [model]="filters().depotTo"
            (modelChange)="setFilter('depotTo', $event)"
            [options]="productDetailService.depotOptions()"
            [icon]="null"
            [dataCyAttribute]="'product-moves-depot-to-filter'"
          ></form-row-select>
        </div>
      }
    </div>
    <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
      <div class="row mr-0">
        <div class="col-12 col-sm-6 col-md-3 col-xl-2">
          <form-row-select
            [label]="'purpose'"
            [icon]="null"
            [options]="purposes()"
            [model]="filters().purpose"
            (modelChange)="setFilter('purpose', $event)"
            [dataCyAttribute]="'product-moves-purpose-filter'"
          ></form-row-select>
        </div>
      </div>
    </div>
  </div>
</app-filter-form>

<div class="card mb-0">
  <div
    class="card-body p-0"
    [ngClass]="{ h150: !productMoves() || (productMoves() && !productMoves()?.length && loading()) }"
  >
    <loading-spinner [isLoading]="loading()" [classesString]="'pt-6'"></loading-spinner>
    @if (!productMoves() || (productMoves() && !productMoves()?.length && !loading())) {
      <div class="empty-list text-center p-5">
        <i class="far fa-sad-tear" data-cy="empty"></i>
        <div>
          {{ 'no.record.found' | translate }}
        </div>
      </div>
    }
    <div class="table-wrap table_responsive">
      @if (productMoves().length) {
        <table class="table mb-0">
          <thead>
            <tr>
              <th scope="col" class="cursor-pointer text-nowrap fixed-column-width ps-0" (click)="sortBy('created')">
                {{ 'dateCreated' | translate }}
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-caret-up': sortProp() === 'created' && sortDir() === 'asc',
                    'fa-caret-down': sortProp() === 'created' && sortDir() === 'desc'
                  }"
                ></i>
              </th>
              <th class="text-nowrap" scope="col">
                {{ 'number' | translate }}
              </th>
              <th class="text-nowrap" scope="col">
                {{ 'externalReference' | translate }}
              </th>
              <th class="text-nowrap" scope="col">
                @if (selectedOperationType !== 'in') {
                  <span>
                    {{ 'depotFrom' | translate }}
                  </span>
                }
                @if (selectedOperationType !== 'in' && selectedOperationType !== 'out') {
                  <span>/</span>
                }
                @if (selectedOperationType !== 'out') {
                  <span>
                    {{ 'depotTo' | translate }}
                  </span>
                }
              </th>
              <th class="text-start" scope="col">
                {{ 'position' | translate }}
              </th>
              <th class="text-nowrap" scope="col">
                <span>
                  {{ 'product.expirationDate' | translate }}
                </span>
                /
                <span>
                  {{ 'product.batch' | translate }}
                </span>
              </th>
              <th class="text-center" scope="col">
                {{ 'type' | translate }}
              </th>
              <th scope="col" class="text-center">
                {{ 'operation.amount' | translate }}
              </th>
              <th scope="col">
                {{ 'order' | translate }}
              </th>
              <th scope="col">
                {{ 'createdBy' | translate }}
              </th>
              <th class="pe-0 fixed-column-width" scope="col">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            @for (move of productMoves(); track move) {
              <tr>
                <td class="text-nowrap ps-1">
                  {{ move.created ? (move.created | strToDate | date: 'dd.MM.yyyy HH:mm') : '' }}
                </td>
                <td class="text-start text-nowrap">
                  {{ move && move.pack && move.pack.number ? move.pack.number : '' }}
                </td>
                <td class="text-start text-nowrap">
                  {{ move && move.pack && move.pack.externalReference ? move.pack.externalReference : '' }}
                </td>
                <td class="text-nowrap">
                  @if (selectedOperationType !== 'in' && move.depotFromObj && move.depotFromObj.id > 0) {
                    <span>
                      <a>
                        {{ move.depotFromObj.name }}
                      </a>
                    </span>
                  }
                  @if (
                    selectedOperationType !== 'in' &&
                    move.depotFromObj &&
                    move.depotFromObj.id > 0 &&
                    selectedOperationType !== 'out' &&
                    move.depotToObj &&
                    move.depotToObj.id > 0
                  ) {
                    <span>/</span>
                  }
                  @if (selectedOperationType !== 'out' && move.depotToObj && move.depotToObj.id > 0) {
                    <span>
                      <!--              class="product-link" [routerLink]="['/depot', move.depotToObj.id]"-->
                      <a>
                        {{ move.depotToObj.name }}
                      </a>
                    </span>
                  }
                  @if (selectedOperationType === 'transfer') {
                    <span>
                      @if (move.depotFromObj && move.depotFromObj.id > 0) {
                        <span>
                          {{ move.depotFromObj.name }}
                        </span>
                      }
                      @if (move.depotFromObj && move.depotFromObj.id > 0 && move.depotToObj && move.depotToObj.id > 0) {
                        <span>/</span>
                      }
                      @if (move.depotToObj && move.depotToObj.id > 0) {
                        <span>
                          {{ move.depotToObj.name }}
                        </span>
                      }
                    </span>
                  }
                </td>
                <td class="text-start text-nowrap">
                  {{ !!move.position && move.position.length > 2 ? move.position : '' }}
                </td>
                <td class="text-start text-nowrap">
                  @if (move.expirationDate && !move.expirationDate.includes('00:00:00')) {
                    <span>
                      {{ move.expirationDate | fmtDate: 'dd.MM.yyyy HH:mm' }}
                    </span>
                  }
                  @if (move.expirationDate && move.expirationDate.includes('00:00:00')) {
                    <span>
                      {{ move.expirationDate | fmtDate: 'dd.MM.yyyy' }}
                    </span>
                  }
                  @if (move.expirationDate && move.batch) {
                    <span>/</span>
                  }
                  @if (move.batch) {
                    <span>
                      {{ move.batch }}
                    </span>
                  }
                </td>
                <td class="text-nowrap text-center">
                  @if (move.pack.type.id === 'in') {
                    <span class="in-badge" title="{{ move.pack.type.id | translate }}">
                      <!--              {{move.pack.type.name | trans}}-->
                      <i class="fas fa-plus-square"></i>
                    </span>
                  }
                  @if (move.pack.type.id === 'out') {
                    <span class="out-badge" title="{{ move.pack.type.id | translate }}">
                      <!--              {{move.pack.type.name | trans}}-->
                      <i class="fas fa-minus-square"></i>
                    </span>
                  }
                  @if (move.pack.type.id === 'transfer') {
                    <span class="transfer-badge" title="{{ move.pack.type.id | translate }}">
                      <!--              {{move.pack.type.name | trans}}-->
                      <i class="fas fa-exchange-alt"></i>
                    </span>
                  }
                  @if (move.pack.type.id === 'reservation') {
                    <span class="reservation-badge" title="{{ move.pack.type.id | translate }}">
                      <!--              {{move.pack.type.name | trans}}-->
                      <i class="fas fa-clock"></i>
                    </span>
                  }
                </td>
                <td class="text-center text-nowrap">
                  <strong>
                    {{
                      move.amount === 0 || move.amount === null
                        ? '0'
                        : (move.amount | number: '1.0-2' | replaceCommaToDot)
                    }}
                  </strong>
                </td>
                <td class="text-start text-nowrap">
                  <div class="flex-gap-5 flex-row-reverse flex justify-content-md-end">
                    <!--              <h1>{{move.pack.order.items | log}}</h1>-->
                    @if (move?.pack?.order?.id) {
                      <app-order-preview [order]="move?.pack?.order"> </app-order-preview>
                    }
                  </div>
                </td>
                <td>
                  @if (move.createdBy && move.createdBy.id > 0) {
                    <span class="text-nowrap">
                      <a class="link" [routerLink]="['/user', move.createdBy.id]" [title]="move.createdBy.email">
                        {{
                          move.createdBy.firstName && move.createdBy.firstName.length
                            ? move.createdBy.firstName + ' ' + move.createdBy.lastName
                            : move.createdBy.email
                        }}
                      </a>
                    </span>
                  }
                </td>
                <td class="pe-1">
                  <a
                    class="btn-second"
                    [routerLink]="['/product-move-pack', move.pack.id]"
                    [queryParams]="{ returnProductId: productDetailService.product?.id }"
                  >
                    {{ 'open' | translate }}
                    <i class="far fa-chevron-right align-self-center"></i>
                  </a>
                </td>
              </tr>
            }
            @if (totalItems() > productMoves().length) {
              <tr>
                <td colspan="12" class="p-0 border-0 no-hover text-center">
                  <!--              todo queryTags.fetchNextPage($event)-->
                  @if ((!currentPage || currentPage <= endPage) && totalItems() > productMoves().length) {
                    <app-pagination-btn (switchPage)="queryProductMoves.fetchNextPage()" [loadingPage]="loading()">
                    </app-pagination-btn>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
